/* Belvori — theme scripts. No dependencies. */
(function () {
  'use strict';

  var T = window.Belvori || {};

  /* ---------------------------------------------------------------- utils */

  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts || false); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount}}';
    var value = (cents / 100);
    function withDelims(num, decimals, thousand, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        default: return withDelims(value, 2, '.', ',');
      }
    });
  }

  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(container) {
    function handler(e) {
      if (e.key !== 'Tab') return;
      var items = $$(focusableSelector, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  var scrollLockCount = 0;
  function lockScroll(lock) {
    scrollLockCount = Math.max(0, scrollLockCount + (lock ? 1 : -1));
    document.body.classList.toggle('no-scroll', scrollLockCount > 0);
  }

  /* ------------------------------------------------------- scroll reveal */

  function initReveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --------------------------------------------------------- sticky header */

  function initHeader() {
    var header = $('.header-wrapper');
    if (!header) return;
    var last = 0;
    function update() {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 8);
      last = y;
    }
    update();
    on(window, 'scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  }

  /* -------------------------------------------------------- mobile drawer */

  function initMenuDrawer() {
    var drawer = $('#MenuDrawer');
    if (!drawer) return;
    var toggle = $('.header__menu-toggle');
    var release = null;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      release = trapFocus(drawer);
      var first = $(focusableSelector, drawer);
      if (first) setTimeout(function () { first.focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      if (release) { release(); release = null; }
      if (lastFocus) lastFocus.focus();
    }

    on(toggle, 'click', open);
    $$('[data-menu-close]', drawer).forEach(function (el) { on(el, 'click', close); });
    $$('a', drawer).forEach(function (a) { on(a, 'click', close); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------------------------------------------------------- cart drawer */

  var CartDrawer = {
    el: null,
    release: null,
    lastFocus: null,

    init: function () {
      this.el = $('#CartDrawer');
      if (!this.el) return;
      var self = this;
      /* Der Schließen-Knopf sitzt in .drawer__inner, und dieser Bereich wird beim
         Aktualisieren des Warenkorbs komplett neu geschrieben. Ein direkt gebundener
         Listener ginge dabei verloren – deshalb hängt der Klick am Container. */
      if (!this.el.dataset.closeBound) {
        this.el.dataset.closeBound = '1';
        on(this.el, 'click', function (e) {
          var ziel = e.target && e.target.closest ? e.target.closest('[data-cart-close]') : null;
          if (!ziel) return;
          e.preventDefault();
          self.close();
        });
        on(document, 'keydown', function (e) {
          if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
        });
      }
      this.bindItems();
      $$('[data-cart-open]').forEach(function (el) {
        on(el, 'click', function (e) {
          if (!T.cartDrawer) return;
          e.preventDefault();
          self.open();
        });
      });
    },

    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      this.release = trapFocus(this.el);
      var first = $(focusableSelector, this.el);
      if (first) setTimeout(function () { first.focus(); }, 60);
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (this.release) { this.release(); this.release = null; }
      if (this.lastFocus) this.lastFocus.focus();
    },

    bindItems: function () {
      var self = this;
      $$('[data-cart-qty]', this.el).forEach(function (btn) {
        on(btn, 'click', function () {
          var line = btn.getAttribute('data-line');
          var qty = parseInt(btn.getAttribute('data-cart-qty'), 10);
          self.change(line, qty);
        });
      });
      $$('[data-cart-remove]', this.el).forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          self.change(btn.getAttribute('data-line'), 0);
        });
      });
    },

    change: function (line, quantity) {
      var self = this;
      this.el.classList.add('is-loading');
      fetch(T.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { self.render(data); })
        .catch(function () { window.location.href = T.routes.cart_url; })
        .finally(function () { self.el.classList.remove('is-loading'); });
    },

    render: function (data) {
      var html = data && data.sections && data.sections['cart-drawer'];
      if (!html) { window.location.reload(); return; }
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('#CartDrawer .drawer__inner');
      var current = $('.drawer__inner', this.el);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      this.bindItems();
      this.updateCount(typeof data.item_count === 'number' ? data.item_count : null, parsed);
      document.dispatchEvent(new CustomEvent('belvori:cart:updated', { detail: data }));
    },

    updateCount: function (count, parsed) {
      if (count === null && parsed) {
        var node = parsed.querySelector('[data-cart-count]');
        if (node) count = parseInt(node.getAttribute('data-cart-count'), 10);
      }
      if (count === null || isNaN(count)) return;
      $$('[data-cart-count]').forEach(function (el) {
        el.setAttribute('data-cart-count', count);
        var bubble = el.querySelector('.header__cart-count');
        if (bubble) bubble.textContent = count;
        el.classList.toggle('has-items', count > 0);
      });
    }
  };

  /* --------------------------------------------------------- quantity input */

  function initQuantity(root) {
    $$('.qty', root || document).forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = $('input', wrap);
      $$('button[data-qty-change]', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = btn.dataset.qtyChange === 'plus' ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------ product form */

  function initProductForms(root) {
    $$('form[data-product-form]', root || document).forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';

      /* "Jetzt bezahlen": zuerst in den Warenkorb, dann direkt zur Kasse. */
      var buyReturn = $('[data-buy-return]', form);
      $$('[data-buy-now]', form).forEach(function (b) {
        on(b, 'click', function () {
          form.dataset.buyNow = '1';
          if (buyReturn) buyReturn.disabled = false;
        });
      });
      $$('[data-add-button]', form).forEach(function (b) {
        on(b, 'click', function () {
          delete form.dataset.buyNow;
          if (buyReturn) buyReturn.disabled = true;
        });
      });

      on(form, 'submit', function (e) {
        if (!T.cartDrawer) return;
        e.preventDefault();
        var button = $('[data-add-button]', form);
        var errorEl = $('[data-form-error]', form);
        if (errorEl) errorEl.hidden = true;
        if (button) { button.setAttribute('aria-disabled', 'true'); button.classList.add('is-loading'); }

        var buyNow = form.dataset.buyNow === '1';
        var data = new FormData(form);
        data.delete('return_to');
        data.append('sections', 'cart-drawer');
        data.append('sections_url', window.location.pathname);

        fetch(T.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/javascript' }, body: data })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errorEl) { errorEl.textContent = res.body.description || res.body.message || ''; errorEl.hidden = false; }
              return;
            }
            if (buyNow) { window.location.href = '/checkout'; return; }
            CartDrawer.render(res.body);
            CartDrawer.open();
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (button) { button.removeAttribute('aria-disabled'); button.classList.remove('is-loading'); }
          });
      });
    });
  }

  /* ------------------------------------------------------- variant selection */

  function initVariantPickers(root) {
    $$('[data-variant-picker]', root || document).forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';

      var sectionId = picker.dataset.section;
      var scope = document.getElementById('ProductInfo-' + sectionId) || document;
      var dataEl = $('[data-variant-json]', picker);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);

      function currentOptions() {
        return $$('select[data-option-index], input[data-option-index]:checked', picker)
          .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
          .map(function (el) { return el.value; });
      }

      function update() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });

        var idInput = $('[data-variant-id]', scope);
        var button = $('[data-add-button]', scope);
        var priceWrap = $('[data-price-wrap]', scope);

        $$('[data-selected-value]', picker).forEach(function (el) {
          var idx = parseInt(el.dataset.selectedValue, 10);
          var wert = opts[idx] || '';
          if (el.hasAttribute('data-bundle-qty')) {
            var n = parseInt(wert, 10);
            if (!n || n < 1) n = 1;
            el.textContent = n + ' Stück';
          } else {
            el.textContent = wert;
          }
        });

        if (!match) {
          if (button) {
            button.setAttribute('aria-disabled', 'true');
            var label = $('[data-add-label]', button) || button;
            label.textContent = T.strings.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = match.id;

        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }

        if (priceWrap) {
          var html = '<span class="price__current">' + formatMoney(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<s class="price__compare">' + formatMoney(match.compare_at_price) + '</s>';
            /* Ersparnis in Euro – serverseitig steht sie schon da, beim Wechsel
               muss sie hier mitgebaut werden, sonst verschwindet sie. */
            html += '<span class="badge-sale">Du sparst ' + formatMoney(match.compare_at_price - match.price) + '</span>';
          }
          priceWrap.innerHTML = html;
        }

        if (button) {
          var lbl = $('[data-add-label]', button) || button;
          if (match.available) {
            button.removeAttribute('aria-disabled');
            button.disabled = false;
            lbl.textContent = T.strings.addToCart;
          } else {
            button.setAttribute('aria-disabled', 'true');
            lbl.textContent = T.strings.soldOut;
          }
        }

        if (match.featured_media) {
          var gallery = $('[data-gallery]', document);
          if (gallery) {
            var target = gallery.querySelector('[data-media-id="' + match.featured_media.id + '"]');
            if (target && typeof target.scrollIntoView === 'function') {
              gallery.scrollTo ? gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' }) : null;
            }
          }
        }
      }

      $$('select[data-option-index], input[data-option-index]', picker).forEach(function (el) {
        on(el, 'change', update);
      });
    });
  }

  /* -------------------------------------------------------------- gallery */

  function initGalleries() {
    $$('[data-gallery-root]').forEach(function (root) {
      var main = $('[data-gallery]', root);
      var thumbs = $$('[data-gallery-thumb]', root);
      if (!main) return;

      thumbs.forEach(function (thumb) {
        on(thumb, 'click', function () {
          var idx = parseInt(thumb.dataset.galleryThumb, 10);
          var slide = main.children[idx];
          if (slide) main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });

      var prev = $('[data-gallery-prev]', root);
      var next = $('[data-gallery-next]', root);

      function slideStep() {
        var first = main.firstElementChild;
        if (!first) return main.clientWidth;
        var gap = parseFloat(getComputedStyle(main).columnGap || getComputedStyle(main).gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function updateArrows() {
        var maxScroll = main.scrollWidth - main.clientWidth - 2;
        // Im Rasterlayout (Desktop) gibt es nichts zu scrollen
        var scrollable = maxScroll > 2;
        if (prev) { prev.disabled = !scrollable || main.scrollLeft <= 2; }
        if (next) { next.disabled = !scrollable || main.scrollLeft >= maxScroll; }
      }
      on(prev, 'click', function () { main.scrollBy({ left: -slideStep(), behavior: 'smooth' }); });
      on(next, 'click', function () { main.scrollBy({ left: slideStep(), behavior: 'smooth' }); });
      on(main, 'scroll', function () { window.requestAnimationFrame(updateArrows); });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      var slides = Array.prototype.slice.call(main.children);
      if ('IntersectionObserver' in window && slides.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.6) return;
            var i = slides.indexOf(entry.target);
            thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.dataset.galleryThumb, 10) === i); });
          });
        }, { root: main, threshold: [0.6] });
        slides.forEach(function (s) { io.observe(s); });
      }
    });
  }

  /* --------------------------------------------------------------- slider */

  function initSliders() {
    $$('[data-slider-root]').forEach(function (root) {
      var track = $('[data-slider-track]', root);
      if (!track) return;
      var prev = $('[data-slider-prev]', root);
      var next = $('[data-slider-next]', root);

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      }
      on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      on(next, 'click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      on(track, 'scroll', function () { window.requestAnimationFrame(updateButtons); }, { passive: true });
      on(window, 'resize', updateButtons);
      updateButtons();
    });
  }

  /* ---------------------------------------------------------- accordions */

  function initAccordions() {
    $$('[data-accordion-group]').forEach(function (group) {
      var items = $$('details', group);
      items.forEach(function (item) {
        on(item, 'toggle', function () {
          if (!item.open || group.dataset.accordionGroup !== 'single') return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

  /* ------------------------------------------------------------ bootstrap */

  function initAll(root) {
    initQuantity(root);
    initProductForms(root);
    initVariantPickers(root);
  }


  /* --------------------------------------------------- feste Kaufleiste */

  function initStickyBuy() {
    var bar = document.querySelector("[data-sticky-buy]");
    if (!bar) return;
    var trigger = document.querySelector(".hero") || document.querySelector("main > *");
    if (!trigger) return;

    bar.hidden = false;

    var buySection = document.getElementById("kaufen");

    /* Kaufleiste an den Kaufbereich koppeln: Preis und gewaehltes Bundle
       werden von dort gespiegelt, damit beide nie auseinanderlaufen. */
    (function syncMitKaufbereich() {
      var quelle = document.querySelector("[data-price-wrap]");
      var preis = bar.querySelector("[data-sticky-price]");
      var titel = bar.querySelector("[data-sticky-title]");
      var titelOriginal = titel ? titel.textContent : "";
      if (!quelle || !preis) return;

      function uebernehmen() {
        preis.innerHTML = quelle.innerHTML;
        if (!titel) return;
        var gewaehlt = document.querySelector(".bundle-cards__input:checked");
        var karte = gewaehlt ? gewaehlt.nextElementSibling : null;
        var name = karte ? karte.querySelector(".bundle-card__qty") : null;
        var anzahl = karte ? karte.querySelector(".bundle-card__count") : null;
        if (name) {
          titel.textContent = anzahl
            ? name.textContent.trim() + " · " + anzahl.textContent.trim()
            : name.textContent.trim();
          titel.classList.add("is-bundle");
        } else {
          titel.textContent = titelOriginal;
          titel.classList.remove("is-bundle");
        }
      }

      uebernehmen();
      if ("MutationObserver" in window) {
        new MutationObserver(uebernehmen).observe(quelle, { childList: true, subtree: true, characterData: true });
      }
      $$(".bundle-cards__input").forEach(function (el) { on(el, "change", uebernehmen); });
    })();

    function toggle(show) {
      bar.classList.toggle("is-visible", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }
    toggle(false);

    if (!("IntersectionObserver" in window)) return;

    // Leiste zeigen, sobald der Hero vorbei ist
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(trigger);

    // Leiste ausblenden, solange der Kaufbereich selbst sichtbar ist
    if (buySection) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) toggle(false);
        });
      }, { threshold: 0.25 }).observe(buySection);
    }
  }

  function boot() {
    initReveal();
    initStickyBuy();
    initHeader();
    initMenuDrawer();
    CartDrawer.init();
    initGalleries();
    initSliders();
    initAccordions();
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initReveal();
    initStickyBuy();
    initGalleries();
    initSliders();
    initAccordions();
    initHeader();
    initMenuDrawer();
    CartDrawer.init();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.id === 'shopify-section-cart-drawer') CartDrawer.open();
  });

  window.BelvoriCart = CartDrawer;
})();
